import { Translations } from './fr';

export const zh: Translations = {
  nav: {
    home: "首页",
    primeEvolution: "进化",
    pulse: "脉搏",
    sparkle: "闪耀",
    agents: "代理",
    partners: "合作伙伴",
    contact: "联系我们",
    recruitAgent: "招聘代理",
  },
  hero: {
    title: "招聘我们的",
    titleHighlight: "AI代理",
    titleEnd: "来强化您的团队",
    subtitle: "24/7全天候可用的虚拟协作者，接受过您业务流程培训，随时准备转变您的生产力。",
    cta: "招聘AI代理",
    discover: "探索Prime Evolution",
  },
  trust: {
    available: "24/7全天候",
    secure: "100%安全",
    agents: "认证代理",
    support: "专属支持",
  },
  primeEvolution: {
    badge: "我们的旗舰解决方案",
    title: "Prime Evolution",
    subtitle: "将AI集成到您企业的完整支持计划",
    description: "Prime Evolution是我们的整体方法，结合审计、培训和定制AI代理的部署，以持续转变您的组织。",
    features: {
      audit: { title: "战略审计", description: "深入分析您的流程，识别高影响力的自动化机会。" },
      training: { title: "团队培训", description: "定制培训计划，让您的团队掌握并有效地与AI协作。" },
      deployment: { title: "定制部署", description: "个性化AI代理，集成您现有的工具，并根据您的业务数据进行培训。" },
      support: { title: "持续支持", description: "专属支持和持续优化，以最大化您的投资回报。" },
    },
    cta: "开始Prime Evolution",
    stats: { productivity: "平均生产力提升", roi: "投资回报率", satisfaction: "客户满意度" },
  },
  pulse: {
    badge: "智能自动化",
    title: "VEECTORIA Pulse",
    subtitle: "与您企业节奏同步的自动化",
    description: "Pulse是我们的智能自动化平台，实时连接、协调和优化您的工作流程。",
    features: {
      connect: { title: "连接", description: "与200多种专业工具和平台原生集成。" },
      orchestrate: { title: "协调", description: "智能工作流程，自动适应您的需求。" },
      optimize: { title: "优化", description: "实时分析和建议，改进您的流程。" },
    },
    cta: "探索Pulse",
  },
  advantages: {
    badge: "为什么选择我们",
    title: "VEECTORIA优势",
    subtitle: "结合人类专业知识和AI力量的独特方法",
    items: {
      expertise: { title: "公认的专业知识", description: "在数字化转型和AI方面拥有10多年的经验。" },
      custom: { title: "定制解决方案", description: "每个代理都专门针对您的流程和数据进行培训。" },
      security: { title: "最高安全性", description: "数据托管在欧洲，保证GDPR合规。" },
      roi: { title: "保证ROI", description: "承诺可衡量的结果。" },
      support: { title: "24/7支持", description: "专属团队随时为您提供支持。" },
      evolution: { title: "持续进化", description: "您的代理通过机器学习不断改进。" },
    },
  },
  sparkle: {
    badge: "智能数字化",
    title: "Sparkle",
    subtitle: "AI驱动的TagPDF v7",
    description: "借助我们的智能数字化解决方案，将纸质文档转化为可用数据。自动识别、数据提取和智能分类。",
    features: {
      scan: { title: "高级数字化", description: "适用于所有文档类型的高精度OCR。" },
      ai: { title: "集成AI", description: "关键数据的自动分类和提取。" },
      speed: { title: "超快处理", description: "数千页在几分钟内处理完成。" },
      accuracy: { title: "最高精度", description: "识别率超过99%。" },
    },
    cta: "探索Sparkle",
    ctaFulltext: "全文索引",
    ctaFulltextDesc: "即时搜索所有文档。",
    ctaScan: "闪电扫描 → 文件夹",
    ctaScanDesc: "眨眼间完成扫描和整理。",
  },
  testimonials: {
    badge: "客户评价",
    title: "他们信任我们",
    subtitle: "了解我们的客户如何通过VEECTORIA转变他们的业务",
    items: [
      { quote: "感谢VEECTORIA，我们将行政任务减少了70%。", metric: "-70%", metricLabel: "行政时间", name: "伊莎贝尔 G.", role: "行政经理" },
      { quote: "商业AI代理转变了我们的潜在客户开发。合格预约增加40%。", metric: "+40%", metricLabel: "合格预约", name: "马克 D.", role: "销售总监" },
      { quote: "文档解决方案在文件管理方面为我们节省了宝贵的时间。", metric: "5x", metricLabel: "更快", name: "索菲 M.", role: "经理" },
    ],
  },
  faq: {
    badge: "常见问题",
    title: "关于VEECTORIA的一切",
    subtitle: "您最常见问题的答案",
    items: {
      q1: { question: "什么是VEECTORIA AI代理？", answer: "VEECTORIA AI代理是一个智能虚拟协作者，针对您的特定业务流程进行培训。它可以处理各种任务：客户支持、数据分析、写作、行政管理等。" },
      q2: { question: "部署代理需要多长时间？", answer: "标准部署需要2到4周，包括初始审计、配置、数据培训和测试。对于更复杂的需求，需要6到8周。" },
      q3: { question: "我的数据安全吗？", answer: "绝对安全。所有数据都托管在欧洲的认证服务器上。我们100%符合GDPR，并应用最高安全标准（加密、受控访问、定期审计）。" },
      q4: { question: "预期的投资回报是多少？", answer: "我们的客户平均看到40%的生产力提升，并在前3个月内实现正向ROI。我们承诺可衡量的结果。" },
      q5: { question: "与现有工具的集成是如何工作的？", answer: "VEECTORIA与200多种专业工具（CRM、ERP、通信工具等）原生集成。我们的技术团队确保顺利集成，不会中断您的运营。" },
    },
  },
  contact: {
    badge: "联系我们",
    title: "准备好转变您的业务了吗？",
    subtitle: "让我们讨论您的需求，了解VEECTORIA如何支持您",
    form: {
      name: "全名",
      email: "工作邮箱",
      company: "公司",
      phone: "电话",
      message: "您的留言",
      submit: "发送消息",
      sending: "发送中...",
      success: "消息发送成功！",
      error: "发送错误。请重试。",
    },
    info: { title: "联系信息", email: "邮箱", phone: "电话", address: "地址" },
  },
  cta: {
    title: "准备好行动了吗？",
    subtitle: "加入已经通过VEECTORIA转变生产力的企业",
    button: "招聘AI代理",
  },
  footer: {
    description: "人工智能解决方案，转变您的业务。",
    navigation: "导航",
    legal: "法律声明",
    privacy: "隐私政策",
    terms: "条款和条件",
    cookies: "Cookie设置",
    rights: "保留所有权利。",
  },
  agents: {
    badge: "我们的团队",
    title: "我们的AI代理",
    subtitle: "了解我们随时准备加入您团队的虚拟协作者",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "AI卓越服务您的企业",
    title: "我们的AI代理改变您的日常工作",
    description: "想象一支永不休息、持续学习、完美适应您业务流程的虚拟团队。我们的AI代理增强您的能力，将您的人才从重复性任务中解放出来，并将您的生产力提升到新的高度。",
    imageAlt: "VEECTORIA AI代理团队",
    cta: "发现我们的代理",
    benefits: {
      availability: "全天候可用",
      productivity: "生产力提升10倍",
      performance: "最佳性能",
      collaboration: "无缝协作",
    },
  },
  cookies: {
    title: "Cookie管理",
    message: "我们使用Cookie来改善您在网站上的体验、分析流量并个性化内容。",
    accept: "全部接受",
    decline: "拒绝",
    settings: "自定义",
    settingsTitle: "Cookie设置",
    settingsDescription: "管理您的Cookie偏好。必要Cookie对于网站运行是必需的，无法禁用。",
    saveChoices: "保存我的选择",
    rejectAll: "全部拒绝",
    alwaysActive: "始终活跃",
    categories: {
      essential: { name: "必要Cookie", description: "这些Cookie对于网站运行是必需的，无法禁用。" },
      analytics: { name: "分析Cookie", description: "这些Cookie使我们能够衡量网站受众并分析浏览行为。" },
      marketing: { name: "营销Cookie", description: "这些Cookie用于提供个性化广告。" },
      preferences: { name: "偏好Cookie", description: "这些Cookie会记住您的偏好（语言、主题、地区）。" },
    },
  },

  // Partners Section
  partners: {
    badge: "合作伙伴计划",
    title: "让我们共同发展",
    description: "您是经销商、分销商、软件编辑商还是批发商？VEECTORIA成为您的首选技术合作伙伴，用尖端人工智能解决方案征服新市场。",
    valueProposition: "我们为您的客户设计和开发完整、定制的专业解决方案，同时支持您实施大规模商业化战略。有吸引力的利润、专属技术支持和营销协助：成功的所有要素。",
    types: {
      resellers: { title: "经销商", description: "将我们的AI解决方案集成到您的目录中，提供差异化的产品组合。" },
      distributors: { title: "分销商", description: "在您的区域大规模部署我们的技术。" },
      editors: { title: "软件编辑商", description: "用我们的AI增强您的软件，创造无与伦比的附加值。" },
      wholesalers: { title: "批发商", description: "获得通过您的网络进行大规模分销的优惠价格。" },
    },
    benefits: {
      title: "您的合作伙伴优势",
      whiteLabel: "白标解决方案",
      support: "专属技术支持",
      scalability: "无限可扩展性",
    },
    cta: "成为合作伙伴",
    ctaSubtext: "联系我们了解我们的独家合作伙伴计划",
  },

  legal: {
    lastUpdate: "最后更新：2026年1月",
    mentions: {
      title: "法律声明",
      sections: {
        editor: { title: "1. 网站发布者", intro: "本网站由以下机构发布：", companyName: "公司名称", legalForm: "法律形式", capital: "注册资本", address: "注册地址", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "增值税号", naf: "NAF代码" },
        publication: { title: "2. 发布负责人", intro: "发布由以下机构管理：", since: "自" },
        contact: { title: "3. 联系方式", phone: "电话", email: "邮箱" },
        hosting: { title: "4. 托管", intro: "网站由以下机构托管：", name: "名称", address: "地址" },
        intellectual: { title: "5. 知识产权", content1: "本网站全部内容受法国和国际版权及知识产权法律保护。所有复制权利保留。", content2: "未经明确授权，严禁以任何形式复制本网站的全部或部分内容" },
        liability: { title: "6. 责任限制", content: "本网站信息尽可能准确。{company}不对因使用本网站而产生的直接或间接损害承担责任。" },
        law: { title: "7. 适用法律", content: "本网站受法国法律管辖。如发生争议，法国法院具有专属管辖权。" },
      },
    },
    privacy: {
      title: "隐私政策",
      sections: {
        intro: { title: "1. 简介", content: "{company}致力于保护其网站用户的隐私。本隐私政策解释了我们如何根据《通用数据保护条例》(GDPR)收集、使用和保护您的个人数据。" },
        controller: { title: "2. 数据控制者", company: "公司", address: "地址", email: "邮箱" },
        data: { title: "3. 收集的数据", intro: "我们收集以下数据：", items: ["身份数据：姓名、邮箱、电话", "职业数据：公司、职位", "浏览数据：IP地址、Cookie、访问页面", "通信数据：通过表单发送的消息"] },
        purposes: { title: "4. 处理目的", intro: "收集您的数据用于：", items: ["回复您的联系和演示请求", "提供我们的AI服务和解决方案", "改进我们的网站和服务", "发送商业通信（经您同意）", "遵守法律义务"] },
        basis: { title: "5. 法律依据", intro: "数据处理基于：", items: ["您的明确同意", "合同执行", "我们的合法利益", "法律义务合规"] },
        retention: { title: "6. 保留期限", content: "您的个人数据将在收集目的所需的期限内保留，最长为您最后一次联系后3年。" },
        rights: { title: "7. 您的权利", intro: "根据GDPR，您拥有以下权利：", access: "访问权", accessDesc: "获取您数据的副本", rectification: "更正权", rectificationDesc: "更正不准确的数据", erasure: "删除权", erasureDesc: "请求删除您的数据", restriction: "限制权", restrictionDesc: "限制数据处理", portability: "可携带权", portabilityDesc: "以结构化格式接收数据", objection: "反对权", objectionDesc: "反对数据处理", contact: "要行使这些权利，请联系我们：" },
        security: { title: "8. 安全", content: "我们实施适当的技术和组织措施，保护您的数据免受未经授权的访问、修改、披露或销毁。" },
        complaint: { title: "9. 投诉", content: "如果您认为您的权利未得到尊重，您可以向CNIL提出投诉：www.cnil.fr" },
      },
    },
    cgv: {
      title: "条款和条件",
      sections: {
        object: { title: "1. 目的", content: "本条款和条件规定{company}与其客户之间关于人工智能服务、软件开发和商业解决方案的合同关系。" },
        provider: { title: "2. 服务提供商", company: "公司", siret: "SIRET", address: "地址" },
        services: { title: "3. 提供的服务", intro: "{company}提供以下服务：", items: ["专业AI代理（转录、管理、支持等）", "定制商业应用开发（Prime Evolution）", "文档AI解决方案", "VEECTORIA Pulse - 转录和报告平台", "AI解决方案咨询和集成"] },
        quotes: { title: "4. 报价和订单", content: "所有服务均需详细报价。签署报价并收到约定的定金后，订单即被视为最终确定。" },
        pricing: { title: "5. 定价和付款", content1: "价格以欧元（不含税）报价。适用的增值税为20%。除非另有说明，发票应在月底后30天内支付。", content2: "如延迟付款，将按法定利率的3倍收取滞纳金，另加40欧元的催收费用固定补偿。" },
        delivery: { title: "6. 交付和期限", content: "交付时间为参考性质。{company}承诺遵守报价中约定的期限，除非有特殊情况。" },
        intellectual: { title: "7. 知识产权", content: "除非另有约定，{company}开发的内容在全额付款前仍为其财产。付款后，使用权将根据合同规定的条款转让给客户。" },
        confidentiality: { title: "8. 保密", content: "双方承诺在商业关系框架内交换的信息在合同结束后3年内保密。" },
        liability: { title: "9. 责任限制", content: "{company}的责任限于相关合同实际收到的金额。{company}不对间接损害承担责任。" },
        law: { title: "10. 适用法律", content: "本条款和条件受法国法律管辖。任何争议应提交至巴黎管辖法院。" },
      },
    },
    cookiesPolicy: {
      title: "Cookie政策",
      sections: {
        what: { title: "1. 什么是Cookie？", content: "Cookie是访问网站时放置在您设备（计算机、平板电脑、智能手机）上的小型文本文件。它允许网站记住有关您访问的信息。" },
        types: { title: "2. 使用的Cookie", intro: "我们的网站使用以下类型的Cookie：", essential: "必要Cookie", essentialDesc: "网站运行所必需的。无法禁用。", analytics: "分析Cookie", analyticsDesc: "帮助我们了解您如何使用我们的网站以进行改进。", preferences: "偏好Cookie", preferencesDesc: "记住您的选择（语言、主题）以个性化您的体验。" },
        retention: { title: "3. 保留期限", content: "根据CNIL建议，Cookie最长保留13个月。" },
        management: { title: "4. Cookie管理", intro: "您可以随时通过浏览器设置更改Cookie偏好：", items: ["Chrome：设置 → 隐私和安全 → Cookie", "Firefox：选项 → 隐私和安全 → Cookie", "Safari：偏好设置 → 隐私 → Cookie", "Edge：设置 → Cookie和站点权限"] },
        contact: { title: "5. 联系", content: "如有关于Cookie使用的任何问题，请联系我们：" },
      },
    },
  },
};